module.exports = __webpack_public_path__ + "static/Gibson-Regular-webfont-761a8b78ca84383dae7c6de0e33ec114.eot";